var mentions_default = {
  "mentionPalette": "hkPQs",
  "mention": "duADr",
  "mentionViewer": "WDC-4",
  "mentionSuggestionsEntry": "U-3N-",
  "mentionSuggestionsEntryFocused": "vRKoU",
  "mentionSuggestionsEntryText": "_2PmT3",
  "mentionSuggestionsEntryAvatar": "_5-Vai",
  "mentionSuggestions": "WYJls",
  "cursorDefault": "U-BmL",
  "cursorPointer": "aPFNw"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
